import React, { Component } from 'react';
import { ImportExportView } from '../../components';
import s from './HostStyles.module.scss';

export default class ImportExportViewHost extends Component {
    constructor(props) {
        super(props);
        this.state = { foo: 'Foo' };
    }

    render() {
        return (
            <div className={s.editor} style={{ padding: '100px', background: '#f6f6f6' }}>
                <ImportExportView foo={this.state.foo} />
            </div>
        );
    }
}
